import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Option } from '../ControlledFields/ControlledSelect';
import { ControlledSelect } from '../index';

type Props = {
  disabled?: boolean;
  name?: string;
  onChange?: (value: string | number) => void;
};

const CLASelect = ({ disabled = false, name = 'claId', onChange }: Props) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  const data = useGetOptionsForCLA();

  return (
    <ControlledSelect
      disabled={disabled}
      control={control}
      variant="outlined"
      label={t('salaryScales.grid.claId')}
      name={name}
      options={data as Option[]}
      handleSelect={onChange}
    />
  );
};

export default CLASelect;
